import sessionStore from 'client/Session/SessionStore';
import {resource} from '@albert-io/json-api-framework/request/builder';

export function getAuthorQuery() {
  return resource('author_v1')
    .mandarkEndpoint(['authors_v1', sessionStore.getUserId()])
    .include('authoring_subjects_v1')
    .filter({
      authoring_subjects_v1: {
        published: true
      }
    });
}
